export function authenticateUser(text) {
	return {
		type: 'AUTHENTICATE_USER',
		text,
	};
}
